import PropTypes from "prop-types";
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import validator from "validator";

import Modal from "../Modal";
import { SubmitButton } from "@/components/common/SubmitButton";

class DeviceEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      device_id: 0,
      device_name: "",
      device_code: "",
      sort: "",
      timestamp: "",
      error: {},
      loading: false,
    };

    this.handleChangeName = this.handleChangeName.bind(this);
    this.handleChangeCode = this.handleChangeCode.bind(this);
    this.handleChangeSort = this.handleChangeSort.bind(this);
    this.handleSave = this.handleSave.bind(this);
  }

  componentDidMount() {
    this.props.setUnloadAlert();
  }

  componentWillUnmount() {
    this.props.clearUnloadAlert();
  }

  // eslint-disable-next-line react/no-deprecated -- 暫定処置でdisableしている
  componentWillReceiveProps(nextProps) {
    const data = nextProps.data;

    if (data) {
      const { device_id, device_name, device_code, sort, timestamp } = data;

      this.setState({
        device_id,
        device_name,
        device_code,
        sort,
        timestamp,
        loading: false,
        error: {},
      });
    } else {
      this.setState({
        device_id: 0,
        device_name: "",
        device_code: "",
        sort: "",
        timestamp: "",
        loading: false,
        error: {},
      });
    }
  }

  handleChangeName(e) {
    this.setState({
      device_name: e.target.value,
    });
  }

  handleChangeCode(e) {
    this.setState({
      device_code: e.target.value,
    });
  }

  handleChangeSort(e) {
    this.setState({
      sort: e.target.value,
    });
  }

  handleSave() {
    if (this.state.loading) return;
    const error = {};
    const device_name = this.state.device_name ? this.state.device_name.trim() : "";
    const newState = { ...this.state, device_name };

    if (validator.isEmpty(device_name)) {
      error.device_name = "device_name";
      error.msg = "is_required";
    } else if (device_name.length > 100) {
      error.device_name = "device_name";
      error.msg = "is_too_long";
    }

    if (this.state.device_code.length > 100) {
      error.device_code = "device_code";
      error.msg2 = "is_too_long";
    }

    if (!validator.isInt(this.state.sort.toString())) {
      error.sort = "display_order_is_invalid";
    } else if (this.state.sort > 999999999) {
      error.sort = "display_order_maximum";
    } else if (this.state.sort < 0) {
      error.sort = "display_order_negative";
    } else if (this.state.sort.toString().match(/^-0+$/)) {
      newState.sort = 0;
    } else {
      newState.sort = parseInt(this.state.sort, 10);
    }

    newState.error = error;

    if (Object.keys(error).length > 0) {
      this.setState(newState);
    } else {
      newState.loading = true;
      this.setState(newState);
      this.props.saveHandler(
        newState,
        () => this.setState({ loading: false }),
        () => this.setState({ loading: false })
      );
    }
  }

  render() {
    const { device_name, device_code, sort, error, loading } = this.state;
    const { fetching, closeHandler, t } = this.props;

    return (
      <Modal
        title={t("device_dialog_title")}
        loading={fetching}
        closeHandler={closeHandler}
        closeButtonDataTestId="master-device-button-close"
      >
        <div className="modal-body">
          <div className="form-row">
            <div className="form-group w-400">
              <span className="form-label txt-bold">{t("device_name")}</span>
              <input
                data-test-id="master-device-name"
                type="text"
                className="form-control w-290"
                value={device_name}
                onChange={this.handleChangeName}
              />
            </div>
            {error.device_name && (
              <div className="form-error w-400">
                <p className="form-error-message w-290">
                  {t(error.device_name)}
                  {t(error.msg)}
                </p>
              </div>
            )}
          </div>
          <div className="form-row">
            <div className="form-group w-300">
              <span className="form-label txt-bold">{t("device_code")}</span>
              <input
                data-test-id="master-device-code"
                type="text"
                className="form-control w-190"
                value={device_code}
                onChange={this.handleChangeCode}
              />
            </div>
            {error.device_code && (
              <div className="form-error w-400">
                <p className="form-error-message w-290">
                  {t(error.device_code)}
                  {t(error.msg2)}
                </p>
              </div>
            )}
          </div>
          <div className="form-row">
            <div className="form-group w-230">
              <span className="form-label txt-bold">{t("display_order")}</span>
              <input
                data-test-id="master-device-sort"
                type="number"
                min="0"
                className="form-control w-120"
                value={sort}
                onChange={this.handleChangeSort}
              />
            </div>
            {error.sort && (
              <div className="form-error w-400">
                <p className="form-error-message w-290">{t(error.sort)}</p>
              </div>
            )}
          </div>
        </div>
        <div className={"modal-footer"}>
          <button
            data-test-id="master-device-button-cancel"
            type="button"
            className="btn btn-gray"
            disabled={loading}
            onClick={closeHandler}
          >
            {t("cancel")}
          </button>
          <SubmitButton data-test-id="master-device-button-save" onClick={this.handleSave} loading={loading} />
        </div>
      </Modal>
    );
  }
}

DeviceEditor.defaultProps = {
  data: null,
};

DeviceEditor.propTypes = {
  data: PropTypes.object,
  fetching: PropTypes.bool.isRequired,
  closeHandler: PropTypes.func.isRequired,
  saveHandler: PropTypes.func.isRequired,
  setUnloadAlert: PropTypes.func.isRequired,
  clearUnloadAlert: PropTypes.func.isRequired,
};

export default withTranslation()(DeviceEditor);
